import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamLookupComponent } from './team-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TeamLookupComponent],
  exports: [TeamLookupComponent]
})
export class TeamLookupModule { }
